var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-trash-alt",
    "data-name": "Icon awesome-trash-alt",
    d: "M1.429,20.844A2.15,2.15,0,0,0,3.571,23H16.429a2.15,2.15,0,0,0,2.143-2.156V5.75H1.429Zm12.143-11.5a.714.714,0,1,1,1.429,0V19.406a.714.714,0,1,1-1.429,0Zm-4.286,0a.714.714,0,1,1,1.429,0V19.406a.714.714,0,1,1-1.429,0ZM5,9.344a.714.714,0,1,1,1.429,0V19.406a.714.714,0,1,1-1.429,0ZM19.286,1.437H13.929L13.509.6a1.071,1.071,0,0,0-.96-.6h-5.1a1.058,1.058,0,0,0-.955.6l-.42.84H.714A.717.717,0,0,0,0,2.156V3.594a.717.717,0,0,0,.714.719H19.286A.717.717,0,0,0,20,3.594V2.156A.717.717,0,0,0,19.286,1.437Z",
    transform: "translate(0 0)",
    fill: "#fbfbfb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashWhite);
export default __webpack_public_path__ + "static/media/trash_white.202dd385c91c0716ccbbb7a20858be2a.svg";
export { ForwardRef as ReactComponent };